// A draft that matches what is already saved is not a change.
export const isSameAsSaved = (saved, draft) => {
  if (Boolean(saved?.isAmend) !== Boolean(draft.isAmend)) return false;
  if (!draft.isAmend) return true;
  return (
    String(saved?.amendDetail || '').trim() ===
    String(draft.amendDetail || '').trim()
  );
};

export const findClause = (gtc, clauseId) => {
  for (const category of gtc?.categories || [])
    for (const article of category.articles || [])
      for (const clause of article.clauses || [])
        if (clause.id === clauseId) return clause;
  return null;
};
